title: Bedrijfsinformatie
fields:
  name: Bedrijfsnaam
  address: Adres
  zipCode: Postcode
  city: Woonplaats
  phoneNumber: Telefoonnummer
  email: E-mailadres
  logo: Logo
  uploadLogo: Logo uploaden
  primaryColor: Hoofdkleur publieke pagina
  images: Foto's publieke pagina
  uploadImages: Foto's toevoegen
  changeLogo: Ander logo kiezen
  removeLogo: Logo verwijderen
labels:
  name: "Bedrijfsnaam:"
  address: "Adres:"
  zipCodeAndCity: "Postcode + Woonplaats:"
  phoneNumber: "Telefoonnummer:"
  email: "E-mailadres:"
  logo: "Logo:"
  primaryColor: "Hoofdkleur publieke pagina:"
  images: "Foto's publieke pagina:"
messages:
  manageCompanyDetails: Beheer algemene informatie en openingstijden
  logo: Upload een afbeelding (PNG, JPG, SVG)
  primaryColor: Kies een kleur die gebruikt wordt voor de publieke boekingspagina. Leeg laten voor standaard 4yourplan kleuren.
  images: Upload één of meerdere foto's die worden getoond op de publieke pagina
subtitles:
  general: Algemeen
  publicPage: Publieke pagina
